<template>
  <div>
      <!-- page wrapper start -->
    <div class="pg-wrapper">
      <app-header>
        <div class="title-bar" slot="header-foot">
          <h1 class="title has-text-black">Verification</h1>
        </div>
      </app-header>

      <main class="content-wrapper pt30 pb30 ">
        <div class="container is-flex">
          <div class="is-flex align-items-center">
            <div class="inner-wrapper has-text-centered" v-if="loaded">
              <img src="@/assets/img/icon-email.svg" alt="email" class="mb20">
              <p class="is-size-15 mb50">{{ message }}</p>
              <button @click="gotoShop()" class="button is-large bg-secondary text-white hover-opacity-7 is-full-width">Start Browsing</button>
            </div>
            <div class="inner-wrapper has-text-centered" v-else>
              <div class="loading-with-text">
                <loading/>
                <p class="is-size-15 mb50">Please wait while we are processing.</p>
              </div>
            </div>
          </div>
        </div>

      </main>
      <app-footer></app-footer>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import UserApis from '@/Components/Controllers/UserApis';
import BusinerssProfileApis from '@/Components/Controllers/BusinerssProfileApis';
import LocationApis from '@/Components/Controllers/LocationApis';
import Helpers from '@/Components/Helpers/Helpers';
import Env from '@/env';

export default {
  name: 'EmailVerified',
  data() {
    return {
      loaded: false,
      message: '',
    };
  },

  computed: {
    ...mapGetters({
      vg_locationSelected: "location/selected",
      vg_businessProfile: "businessprofile/detail", 
    })
  },
  created() {
    // Set the location to blank so that on header it do not show old location, on mount we are refetching and setting selected location
    this.va_setSelectedLocation({});
  },
  async mounted() {
    if(!this.$route.query.token) {
      return this.gotoShop();
    }
    let businessRes = await BusinerssProfileApis.fetchBusinessProfile(this.$route.params.business_slug);
    if(businessRes.status != 200){
      // Its invalid business redirect to valid one
      this.va_snackbar({
        type: "warning",
        message: "Cannot find business."
      });
      return this.$router.push({ 
        name: 'HomePage', 
        params: {
          business_slug: Env.defaultBusinessSlug 
        },
      });
    }
    let locationDetailRes = await LocationApis.fetchBySlug(this.$route.params.store_slug, false);
     if (locationDetailRes.status != 200) {
      this.va_snackbar({
        type: "warning",
        message: "Cannot find the store."
      });
      return this.$router.push({ 
        name: 'HomePage', 
        params: {
          business_slug: this.$route.params.business_slug
        },
      });
    }
    this.va_setSelectedLocation(locationDetailRes.data.payload);
    this.updateEmailPhone();
  },

  methods: {
    /**
     * Verify email/phone update
     */
    async updateEmailPhone() {
      let res = await UserApis.updatePhoneEmailVerification({
        verification_token: this.$route.query.token,
        business_id: this.vg_businessProfile.id ? this.vg_businessProfile.id : null,
        // Extra need to pass
        business_name: this.vg_businessProfile.name ? this.vg_businessProfile.name : '',
        business_slug: this.$route.params.business_slug,
        logo_url: (this.vg_businessProfile && this.vg_businessProfile.branding && this.vg_businessProfile.branding.logo_url) ? this.vg_businessProfile.branding.logo_url : '',
        location_id: this.vg_locationSelected.id ? this.vg_locationSelected.id : '',
        location_slug: this.vg_locationSelected.slug ? this.vg_locationSelected.slug : '',
      });
      this.loaded = true;
      if(res.status == 200){
        this.message = 'Successfully verified.';
        // update user email and token 
        await this.$store.dispatch("SET_USER_TOKEN", res.data.payload.token);
        await this.$store.dispatch("SET_USER_DETAILS", res.data.payload);
      } else {
        this.message = res.response.data.msg;
      }
    },
    /**
     * Go to shop page
     */
    gotoShop() {
      this.$router.push({ 
        name: 'StoreProfile',
        params: {
          business_slug: this.$route.params.business_slug,
          store_slug: this.$route.params.store_slug
        }, 
        query: Helpers.refineQuery(['token', 'business_id', 'updated_email'], this.$route.query)
      });
    },

   ...mapActions({
      // va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
      va_clearCart: "cart/clearCart",
      va_setSelectedLocation: "location/setSelected",
    })

  },
};
</script>
<style scoped>
.loading-with-text{
  position: relative;
}
.loading-with-text p{
  margin-top: -70px;
}
</style>